// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ServiceCategories_SalvarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /so/service_categories/salvar
 *
 * Returns the id of the created or updated service category.
 * Wire shape: `dados: { so_service_category_id: int }`.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface ServiceCategories_SalvarResponseDados {
so_service_category_id?: number
}

export type ServiceCategories_SalvarResponse = ApiResponse<ServiceCategories_SalvarResponseDados>;

registerResponseContract('ServiceCategories_SalvarResponse', {
  so_service_category_id: { type: 'number',  required: false },
})
